import React, { useState } from 'react';

import ListDropdown from '@alltrails/shared/components/ListDropdown';

import iconInfo from '../../Badge/icons/info.svg';
import iconWarning from '../../Badge/icons/warning.svg';
import iconDanger from '../../Badge/icons/danger.svg';

import { AlertType, AlgoliaAlert } from '../../../types/alerts';
import * as styles from './styles/styles.module.scss';
import iconOverflow from './icons/overflow.svg';

type AlertPickerItemProps = {
  alert: AlgoliaAlert;
  onEditClick: () => void;
};

const AlertPickerItem = ({ alert: { name, alert_type, object_id }, onEditClick }: AlertPickerItemProps): JSX.Element => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const icon = {
    [AlertType.INFORMATION]: iconInfo,
    [AlertType.WARNING]: iconWarning,
    [AlertType.CLOSURE]: iconDanger
  }[alert_type];

  const links = [
    {
      label: 'Edit',
      href: '',
      dataTestId: `alert-${object_id}`
    }
  ];

  return (
    <div className={styles.container}>
      <div className={styles.left}>
        <img src={icon} className={styles.icon} alt="hello" />
        <span className={styles.title}>{name}</span>
      </div>
      <ListDropdown
        anchorElement={
          <button type="button">
            <img src={iconOverflow} className={styles.overflowIcon} alt="menu" />
          </button>
        }
        links={links}
        handleLinkClick={onEditClick}
        isDropdownOpen={isDropdownOpen}
        setIsDropdownOpen={setIsDropdownOpen}
      />
    </div>
  );
};

export default AlertPickerItem;
